import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/shared/db/database';
import type { Profile } from '@/shared/db/schema';
import { getCurrentUserId } from '@/shared/db/session-context';

import { profilesRepo } from './repository';

/**
 * Профиль текущего пользователя.
 *
 * `useLiveQuery` подписывается на изменения в IndexedDB: правка роста в
 * настройках сразу пересчитывает ИМТ на вкладке «Здоровье» без ручного
 * обновления состояния и без шины событий.
 */
export function useProfile(): Profile | undefined {
  return useLiveQuery(async () => {
    const userId = getCurrentUserId();
    if (!userId) return undefined;
    const profiles = await db.profiles.where('userId').equals(userId).toArray();
    return profiles.find((profile) => profile.deletedAt === null);
  }, []);
}

/** Доля свободного времени под задачи. Без профиля — методологические 80%. */
export function useLoadFactor(): number {
  const profile = useProfile();
  return profile?.planningLoadFactor ?? 0.8;
}

export async function updateProfile(
  profileId: string,
  patch: Partial<Omit<Profile, 'id' | 'userId' | 'createdAt' | 'updatedAt' | 'deletedAt' | 'revision' | 'syncState'>>,
): Promise<void> {
  await profilesRepo.update(profileId, patch);
}
